export enum AdditionalChargeStatusEnum {
  Pending = 1,
  Approved = 2,
  Declined = 3,
  SupplierRequest = 4,
  InternalRequest = 5,
  SupplierUpdated = 6,
  InternalUpdate = 7,
}

export enum AdditionalExpenseValidationStatusEnum {
  AwaitingValidation = 1,
  ProcessingValidation = 2,
  Approved = 3,
  Failed = 4,
  ManualIntervention = 5,
  NotApplicable = 6,
  ManuallyVerified = 7,
}

export enum AdditionalExpenseValidationTypeEnum {
  DateAndTime = 1,
  Location = 2,
  Amount = 3,
  Toll = 4,
  VRN = 5,
  MaximumAmount = 6,
  MultipleChargeType = 7,
}
